import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import PerformanceGroup from "models/groups/PerformanceGroup";

class MetricClicks extends MetricBase {
    constructor() {
        super({
            field: "metric_clicks",
            defaultVisibility: false,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.tripadvisor.clicks.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.clicks.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.clicks.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricClicks;
